import L from 'leaflet';
import 'leaflet.chinatmsproviders';

export default function(type, options) {
  // 高德地图
  let Gaodimgem;
  let Gaodimga;
  if (type === 'Normal') {
    Gaodimgem = L.tileLayer.chinaProvider('GaoDe.Normal.Map', options);
    Gaodimga = L.tileLayer.chinaProvider('GaoDe.Normal.Annotion', options);
  } else {
    Gaodimgem = L.tileLayer.chinaProvider('GaoDe.Satellite.Map', options);
    Gaodimga = L.tileLayer.chinaProvider('GaoDe.Satellite.Annotion', options);
  }
  const gaode = L.layerGroup([Gaodimgem, Gaodimga]);
  // 天地图
  let tianDiTu;
  let tianDiTuAnnotion;
  options.key = 'bc1ef63661d530c93b525ce01e08dbd7';
  if (type === 'Normal') {
    tianDiTu = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', options);
    tianDiTuAnnotion = L.tileLayer.chinaProvider(
      'TianDiTu.Normal.Annotion',
      options
    );
  } else {
    tianDiTu = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', options);
    tianDiTuAnnotion = L.tileLayer.chinaProvider(
      'TianDiTu.Satellite.Annotion',
      options
    );
  }

  const tiandi = L.layerGroup([tianDiTu, tianDiTuAnnotion]);
  return [gaode, tiandi];
}
